import * as Yup from "yup";

export function initialValues(answer) {
  return {
    content: answer?.content || "",
  };
}

export function validationSchema() {
  return Yup.object({
    content: Yup.string().nullable().required("El contenido es obligatorio"),
  });
}
